import Select from 'components/Atoms/Calculator/Select'
import { useTranslation } from 'react-i18next'

interface FirstStepProps {
  setIsCompany: (isCompany: boolean) => void
}

export default function FirstStep({ setIsCompany }: FirstStepProps) {
  const { t } = useTranslation('calculator')
  return (
    <div className="h-full flex flex-col justify-end">
      <div className="h-full flex flex-col justify-between sm:mt-24 max-sm:gap-6">
        <p>{t('calculator.rightColumn.firstStep.text')}</p>
        <div>
          <p className="font-semibold mb-4">
            {t('calculator.rightColumn.firstStep.labelCTA')}
          </p>
          <div className="flex flex-row gap-4">
            <Select
              text={t('calculator.rightColumn.firstStep.ctaCompany')}
              onClick={() => setIsCompany(true)}
            />
            <Select
              text={t('calculator.rightColumn.firstStep.ctaParticular')}
              onClick={() => setIsCompany(false)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
